import { render, staticRenderFns } from "./Bandiera.vue?vue&type=template&id=eabef672&scoped=true"
import script from "./Bandiera.vue?vue&type=script&lang=js"
export * from "./Bandiera.vue?vue&type=script&lang=js"
import style0 from "./Bandiera.vue?vue&type=style&index=0&id=eabef672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabef672",
  null
  
)

export default component.exports